export enum ActionTypes {
    UPDATE_ID = "UPDATE_ID",
    PUBLISH = "PUBLISH",
    LOAD = "LOAD",
    LOAD_SITE_DATA = "LOAD_SITE_DATA",
}
